import { Contact } from "@models/contact"
import { Absence } from "@models/absence"

export class ContactsStore {

  constructor(
    public contacts: Contact[] = [],
    public activeContact: Contact = new Contact(),
    public editableContact: Contact = new Contact(),
    public editableAbsence: Absence = new Absence(),
    public students: Contact[] = [],
  ) {}

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/store/contacts.ts